module.exports = __webpack_public_path__ + "img/project11_1.2dfb31ea.png";